export default "__VITE_ASSET__BjDTO9qq__"